// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3GeDB","label":"SetPasswdForm_label__266m1"};